import Icon from '@/components/ui/AppIcon';

interface Document {
  id: string;
  type: string;
  name: string;
  icon: string;
  size: string;
  downloadUrl: string;
}

interface DocumentWalletProps {
  documents: Document[];
}

export default function DocumentWallet({ documents }: DocumentWalletProps) {
  return (
    <div className="bg-card rounded-xl shadow-brand p-6 border border-border">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center">
            <Icon name="DocumentTextIcon" size={20} className="text-accent" />
          </div>
          <div>
            <h3 className="font-heading font-semibold text-lg text-foreground">
              Travel Documents
            </h3>
            <p className="text-sm text-muted-foreground">
              Available offline
            </p>
          </div>
        </div>
        <button className="text-sm font-medium text-primary hover:text-secondary transition-colors duration-300">
          Download All
        </button>
      </div>

      <div className="space-y-3">
        {documents.map((doc) => (
          <div
            key={doc.id}
            className="flex items-center justify-between p-4 bg-surface rounded-lg hover:bg-muted transition-colors duration-200"
          >
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                <Icon name={doc.icon as any} size={20} className="text-primary" />
              </div>
              <div>
                <p className="font-medium text-foreground">{doc.name}</p>
                <p className="text-xs text-muted-foreground">{doc.type} • {doc.size}</p>
              </div>
            </div>
            <button className="p-2 hover:bg-background rounded-lg transition-colors duration-200">
              <Icon name="ArrowDownTrayIcon" size={20} className="text-muted-foreground" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}